import { Download } from "lucide-react";
import { Button } from "../../../../../components/ui/button";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "../../../../../components/ui/alert-dialog";

interface DownloadRequestButtonProps {
  onConfirm: () => void;
  disabled?: boolean;
}

export function DownloadRequestButton({
  onConfirm,
  disabled = false,
}: DownloadRequestButtonProps) {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button disabled={disabled} className="gap-2">
          <Download className="h-4 w-4" />
          Solicitar Arquivos de Pagamento
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Solicitar Arquivos de Pagamento</AlertDialogTitle>
          <AlertDialogDescription>
            Deseja solicitar novos arquivos de pagamento por e-mail para os PIX
            com erro listados?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>Confirmar</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
